import { Announcement } from 'ui/announcement/Announcement';
import { OpenNewWindow16 } from 'ui/icons/action/OpenNewWindow16';
import { DocumentationLink } from './Announcements.styled';

export const SamlLockoutAnnouncement = () => (
  <Announcement>
    Account warning: Support for your current SSO method ends on August 1, 2023. For continued
    access, have your IT administrator update your sign-on settings now.&nbsp;
    <DocumentationLink
      href="https://support.iterable.com/hc/articles/11667879575572-2023-Release-Notes-#single-sign-on-sso-migration-begins-today"
      target="_blank"
    >
      Learn more.
      <OpenNewWindow16 />
    </DocumentationLink>
  </Announcement>
);
